import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchStitchingReg, fetchStitchReturnGrpStid } from '../../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchReg, selectStitchReGrpStId, selectStitchReturn } from '../../Selectors/StitchSelector/StitchingSelectors';
import { format_date } from '../../../Utils/Dateutils';

const StitchFinalReturnInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        stMemo: '',
        piMemo: '',
        reMemo: '',
        empNm: '',
        itemNm: '',
        brandNm: '',
        partyNm: '',
        departNm: '',
        totqty: '',
        instruction: '',
        totmat: '',
        returnqty: '',
        balqty: '',
        mtqty: '',
        balmtqty: '',
        remtq: ''
    });
    const [material, setMaterial] = useState([]);
    const [itemSizes, setItemSizes] = useState([]);
    const [finalData, setFinalData] = useState([]);
    const { Id } = useParams();
    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchReGrpStId);
    const stitchReturnlist = useSelector(selectStitchReturn);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchStitchReturnGrpStid(Id));
    }, [Id, dispatch]);

    useEffect(() => {
        if (stitchlist?.data) {
            const item = stitchlist?.data;
            const dt = stitchlist?.finalData?.map(val => format_date(val.dt));
            // console.log(dt);
            const dt2 = dt?.join(',');
            const rememo = stitchlist?.finalData?.map(val => val.reMemo);
            setFormData(prev => ({
                ...prev,
                dt: dt2,
                stMemo: item.stMemo,
                piMemo: item.piMemo,
                reMemo: rememo?.join(','),
                empNm: item.empNm,
                itemNm: item.itemNm,
                brandNm: item.brandNm,
                partyNm: item.partyNm,
                departNm: item.departNm,
                totqty: item.totqty,
                instruction: item.instruction,
                returnqty: item.sumqty,
                balqty: item.remainqty,
                mtqty: item.mtqty,
                balmtqty: item.balmtqty,
                remtq: item.remtq
            }));
        }
        if (stitchlist?.Info2?.length > 0) {
            const value = stitchlist?.Info2;
            setMaterial(value);
            const sumtot = value?.reduce((acc, val) => acc + parseFloat(val.reqty), 0);
            setFormData(prev => ({
                ...prev,
                totmat: sumtot
            }));
        }
        if (stitchlist?.Info?.length > 0) {
            const value2 = stitchlist?.Info?.length > 0 ? {
                size: stitchlist.Info.map(val => val.size),
                issqty: stitchlist.Info.map(val => parseFloat(val.issqty)),
                balqty: stitchlist.Info.map(val => parseFloat(val.reqty)),
            } : [];
            setItemSizes(value2);
        }

    }, [stitchlist]);

    console.log(stitchlist)
    const tableContainerStyle = {
        marginLeft: isDesktop ? '2%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };



    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Job Give Return Info - Final Print</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '2%' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Date</td>
                                    <td style={{ width: '35vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px', fontSize: '1rem' }}>Return Memo</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.reMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Party</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.partyNm}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Stitch Memo</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.stMemo}</td>

                                    <td style={{ width: '200px', fontSize: '1rem' }}>PI Ref. No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.piMemo}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.itemNm}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Department</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.departNm}</td>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Brand</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.brandNm}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.totqty}</td>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Return Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.returnqty}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Pending Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem', color: parseFloat(formData.balqty) > 0 ? 'red' : 'green' }} className='dark-color'>{formData.balqty}</td>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Instruction</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.instruction}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '250px', fontSize: '1rem' }}>Issue Material Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color' >{formData.mtqty}</td>
                                    <td style={{ width: '250px', fontSize: '1rem' }}>Return Material Qty.</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%', fontSize: '1rem' }} className='dark-color'>{formData.remtq}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: '200px', fontSize: '1rem' }}>Pending Material Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%', fontSize: '1rem', color: parseFloat(formData.balmtqty) > 0 ? 'red' : 'green' }} className='dark-color' >{formData.balmtqty}</td>

                                </tr>
                            </tbody>
                        </table>


                        {itemSizes?.size?.length > 0 ?
                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' className='tbl-row'>Size</TableCell>
                                            {itemSizes?.size ? itemSizes?.size?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>

                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                            {itemSizes?.issqty ? itemSizes?.issqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>

                                        <TableRow>
                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' className='tbl-row'>PI Qty.</TableCell>
                                            {itemSizes?.balqty ? itemSizes?.balqty?.map((val, index) => (
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '1rem' }} align='center' key={index}>{val}</TableCell>
                                            )) : null}
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer> : null}

                        {material?.length > 0 &&
                            <div style={{ margin: '2%' }}>
                                <h3>Material Details </h3>

                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ fontSize: '1rem' }}>Sr. No.</th>
                                            <th style={{ fontSize: '1rem' }}>Material Work</th>
                                            <th style={{ fontSize: '1rem' }}>Qty.</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {material?.map((mat, matIndex) => (
                                            <>
                                                <tr key={matIndex}>
                                                    <td style={{ fontSize: '1rem' }}>
                                                        {matIndex + 1}
                                                    </td>
                                                    <td style={{ fontSize: '1rem' }}>
                                                        {mat.materialNm}
                                                    </td>
                                                    <td style={{ fontSize: '1rem' }}>
                                                        {mat.reqty}
                                                    </td>

                                                </tr>
                                            </>
                                        ))}
                                        <tr>
                                            <td> </td>
                                            <td style={{ fontSize: '1rem' }}>
                                                <span className="tot-lump">Total Qty</span>
                                            </td>
                                            <td style={{ fontSize: '1rem' }}>
                                                <span className="tot-lump">{formData.totmat}</span>
                                            </td>

                                        </tr>
                                    </tbody>
                                </table>

                            </div>}
                    </div>
                    <div style={{ margin: '2%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default StitchFinalReturnInfo;
